import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText,  MDBCol, MDBRow  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Modalpayedit extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   id_room:"",
   name_room:"",
   amount:"",

   term:'',
   SUBJCODE:'',
   SUBJNAME:'',
   id_major:'',
   teacher_id:'',
   pay:'',

  
}

//this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.getclassroom();
}


 componentDidMount() {
    //  const { id_send } = this.props.id_send
    //  console.log(id_send);
      this.setState({ term:this.props.term})
      this.setState({ SUBJCODE:this.props.SUBJCODE})
      this.setState({ SUBJNAME:this.props.SUBJNAME})
      this.setState({ teacher_id:this.props.teacher_id})
      this.setState({ id_major:this.props.id_major})
      
    
  }


  handleChange2(event) {    this.setState({pay: event.target.value});  }
  handleChange3(event) {    this.setState({name_room: event.target.value});  }
  handleChange4(event) {    this.setState({amount: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("term", this.state.term);
      datafrm.append("SUBJCODE", this.state.SUBJCODE.substring(0, 7));
      datafrm.append("SUBJNAME", this.state.SUBJNAME);
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("pay", this.state.pay);
      
   Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/updatepay/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   }
   )

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'อัพเดทข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
                 }
        })
        this.toggle()
      //  this.props.getclassroom()

}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 
  }

    render() {
     //   console.log(this.state.pay)
     //   console.log(this.state.name_room)
      //  console.log(this.state.amount)
        
        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle} color="unique" size="sm">จัดการ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>จัดการค่าตอบแทนผู้สอน</MDBModalHeader>
              <MDBModalBody>
              <div>

              <MDBCol sm="12">
      <MDBCard>
        <MDBCardBody>
        <MDBCardTitle>วิชา {this.state.SUBJCODE} {this.state.SUBJNAME} </MDBCardTitle>
          <MDBCardText>
           เทอม {this.state.term} 
          </MDBCardText>
          
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
    <br/>
              {/* <p>{this.state.id_send}</p>
              <p>{this.state.name_room}</p> */}
               <p>เบิกค่าตอบแทน </p>   
               <MDBInput type="text" label="ค่าตอบแทน" value={this.state.pay} onChange={this.handleChange2} outline />

               {/* <p>ชื่อห้อง </p>
               <MDBInput type="text" label="ชื่อห้อง" value={this.state.name_room} onChange={this.handleChange3} outline />

               <p>จำนวนที่นั่ง </p>   
               <MDBInput type="text" label="จำนวนที่นั่ง" value={this.state.amount} onChange={this.handleChange4} outline /> */}
              
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
